// Datalayer Phase 2 — page-load "Landed" event.
//
// Spec (from CanaraHSBC Corporate Website DL-Requirements.xlsx, Sheet1):
//   Condition  : When user lands on any page
//   event name : Landed
//   SectionName: "Landed"
//   eventLabel : pass the page Title
//   PageName / PageType / PageCategory / PageSubCategory : dynamic (URL-derived)
//
// createDataLayer() (in clientlib-datalayer/js/datalayer.js) already derives
// every URL-based variable (PageName, PageType, PageCategory, PageSubCategory,
// FullURL, pagepath1..4, UserDevice, ClientID, etc.) so this caller only needs
// to supply the two values that aren't URL-derivable: sectionName + eventLabel.
//
// Single source of truth for Landed: previously header.js and headerCLP.js
// each fired Landed from their own datalayer object, which (a) missed pages
// that don't have either header (e.g. embedded / error pages), and (b) would
// have fired twice if both components were ever rendered. Those duplicate
// per-header firings have been removed in this change — this file is now
// the only place that pushes Landed.
//
// Guard against double-firing: a per-page flag on window.__chliLandedFired
// so any external code (Adobe Launch rule, manual push, etc.) that does
// fire Landed won't trigger a second push from our chain.

(function fireLandedOnEveryPage() {
    function pushLanded() {
        if (window.__chliLandedFired) {return;}
        if (typeof window.createDataLayer !== "function") {
            // datalayer.js hasn't loaded yet — re-try after a microtask.
            // (createDataLayer is in clientlib-datalayer; this file is in
            // clientlib-base/site. Load order isn't guaranteed across all
            // page templates.)
            setTimeout(pushLanded, 50);
            return;
        }
        window.__chliLandedFired = true;
        try {
            window.createDataLayer("Landed", {
                sectionName: "Landed",
                eventLabel: document.title || "",
            });
        } catch (e) {
            // Reset the flag so a later retry can succeed if this throw was
            // transient (e.g. some upstream code mutating window.dataLayer
            // mid-push). Errors swallowed deliberately — analytics must never
            // break the page.
            window.__chliLandedFired = false;
        }
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", pushLanded);
    } else {
        pushLanded();
    }
})();

// Marker export so webpack treats this as an ES module with side effects
// and doesn't tree-shake the file when imported via the common/**/*.js glob
// in production builds. Same defensive pattern as csp-inline-style.js.
export {};
